/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Col, Form, Popconfirm, Row, Tooltip } from "antd";
import { useState, useRef } from "react";
import { Input, Table, Select } from "antd";
// import Sidebar from "../../../components/AdminComponents/SideNav";
// import { useParams } from "react-router-dom";
// import {
//   ClientMenu,
//   SecondaryNavClient,
// } from "../../../components/AdminComponents/MenuItems";

import {
  // CheckOutlined,
  PlusOutlined,
  MinusOutlined,
  CheckCircleFilled,
  DeleteTwoTone,
  SwapOutlined,
  CloseOutlined,
  CheckOutlined,
  PlusCircleOutlined,
  // PlusCircleOutlined,
} from "@ant-design/icons";
import "../../../pages/Admin-pages/tableStyling.css";
// import ExpanedFirstRow from "./ExpandedFirstRow";

import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import "./modalstyles.css";

import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../icons/ApplicationColor";
import EditableImage from "../../icons/EditIcon";

const ThirdCategoryChild = (props) => {
  const userInfo = useSelector((state) => state.user);

  //console.log(props.manager);

  //   const [top, setTop] = useState(false);

  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //

  // eslint-disable-next-line no-unused-vars
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined onClick={(e) => onExpand(record, e)} />
    ) : (
      <PlusOutlined onClick={(e) => onExpand(record, e)} />
    );
  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
  };
  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const cancel = () => {
    setEditingKey("");
  };

  // eslint-disable-next-line no-unused-vars
  const [applications, setApplications] = useState([]);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!props.active}>
          <Select.Option key={"null"} value={"none"}>
            None
          </Select.Option>
          {props.manager?.map((app) => (
            <Select.Option key={app.id} value={app.id}>
              {app.full_name}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!props.active} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={
              dataIndex === "entity_id"
                ? [
                    {
                      validator: true,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined // ✅ explicitly set undefined for 'manager'
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish21 = async (values) => {
    const row = await form.validateFields();
    row.id = values.id;
    row.status = true;
    row.organization = userInfo.data.organization.id;
    row.created_by = userInfo?.data?.id;
    row.second_category = props?.record?.id;
    console.log(row);

    try {
      await Axios.put(`/thirdcategoryedit/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      props.CreateSuccessful("Third Category has been edited");
      // handleReset();
      cancel();
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail ||
          "Third Category status has not been edited"
      );
    }
  };
  const [top, setTop] = useState(false);
  const columns = [
    {
      title: "HIERARCY NAME",
      dataIndex: "dep_name_2",
      key: "dep_name_2",
      width: 50, // set width to 150px
      editable: false,
    },
    {
      title: capitalizeWords("category"),
      dataIndex: "name",
      key: "name",
      width: 170, // set width to 150px
      editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div
            style={{ padding: "8px", paddingLeft: "60px", fontSize: "13px" }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: capitalizeWords("Secondary Categories"),
      dataIndex: "third_categories",
      key: "third_categories",
      width: 120, // set width to 150px
      // editable: true,
      align: "center",
    },

    {
      title: capitalizeWords("No. Of Courses"),
      dataIndex: "courses",
      key: "courses",
      width: 150, // set width to 150px
      // editable: true,
    },
    {
      title: capitalizeWords("Last Updated"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div style={{ fontSize: "13px" }}>{formatDateWithSuffix(text)}</div>
        );
      },
    },
    {
      title: capitalizeWords("Created At"),
      dataIndex: "created_at",
      key: "created_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div style={{ fontSize: "13px" }}>{formatDateWithSuffix(text)}</div>
        );
      },
    },
    ...(props?.ImpersonateAccess
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "operation",
            width: 80,
            align: "center",
            render: (_, record) => {
              //console.log(record);
              const editable = isEditing(record);
              return editable ? (
                <div>
                  {props.active && (
                    <CheckCircleFilled
                      title="submit"
                      style={{
                        color: "#52c41a",
                        fontSize: "1.8rem",
                        fontWeight: "700",
                      }}
                      onClick={() => onFinish21(record)}
                    />
                  )}

                  <Popconfirm
                    title={
                      props?.active
                        ? "Confirm to Deactivate"
                        : "Confirm to Restore"
                    }
                    // onConfirm={() => {
                    //   props.active
                    //     ? deleteRecord(record)
                    //     : restoreRecord(record);
                    // }}
                  >
                    {props.active ? (
                      <>
                        {record?.can_be_deleted ? (
                          <DeleteTwoTone
                            style={{
                              cursor: "pointer",
                              fontSize: "1.8rem",
                              marginLeft: "0.9rem",
                            }}
                            title="delete"
                            twoToneColor="#eb2f96"
                            onClick={() => {
                              // setNewProduct(false);
                              // handleReset();
                            }}
                          />
                        ) : null}
                      </>
                    ) : (
                      <>
                        <SwapOutlined
                          style={{
                            cursor: "pointer",
                            fontSize: "1.8rem",
                            marginLeft: "0.9rem",
                          }}
                          // onClick={() => {
                          //   handleDelete(record);
                          // }}
                          title="Restore"
                        />
                      </>
                    )}
                  </Popconfirm>
                  <CloseOutlined
                    onClick={() => {
                      cancel();
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                  />
                </div>
              ) : (
                <>
                  <Tooltip title={`EDIT`}>
                    <div style={{ marginLeft: "2.5px" }}>
                      <EditableImage
                        handleRowClick={handleRowClick}
                        recordId={record}
                        disabled={editingKey !== ""}
                      />
                    </div>
                  </Tooltip>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // const data = [
  //   {
  //     key: "0",
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "Willows",
  //   },
  //   {
  //     key: "1",
  //     name: "Screen 2",
  //     platform: "Android",
  //     version: "11.0.0",
  //     upgradeNum: 1000,
  //     creator: "Jane",
  //     createdAt: "Oak",
  //   },
  //   {
  //     key: "2",
  //     name: "Screen 3",
  //     platform: "Web",
  //     version: "2.1.0",
  //     upgradeNum: 200,
  //     creator: "John",
  //     createdAt: "Maple",
  //   },
  // ];

  //console.log(namingData);

  // eslint-disable-next-line no-unused-vars

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");
  const formRef2 = useRef();
  // const handleReset = () => {
  //   formRef2.current.resetFields();
  //   props.LoadUser();
  // };
  const [form1] = Form.useForm();

  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.organization = userInfo.data.organization.id;
    values.created_by = userInfo?.data?.id;
    values.status = true;
    values.second_category = props?.record?.id;
    try {
      await Axios.post("/thirdcategorycreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setTop(false);
      // handleReset();
      cancel();
      props.CreateSuccessful("Third Category has been created");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Third Category has not been created"
      );
    }
  };
  return (
    <>
      <Form form={form} component={false} style={{ margin: 0, padding: 0 }}>
        <div className="my-custom-table-wrapper">
          <Table
            bordered
            pagination={false}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            showHeader={false}
            columns={mergedColumns}
            dataSource={props.data}
            style={{ margin: 0, padding: 0 }}
            rowClassName="editable-row expanded-row-table-row-2"
            className="secondExpand-table"
            rowKey="id"
          />
        </div>
        {!top ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1rem",
            }}
          >
            <Button
              onClick={() => {
                setTop(true);
              }}
              disabled={!props?.ImpersonateAccess}
              style={{
                background: "white",
                fontWeight: "500",
                fontSize: "1.3rem",
                marginLeft: "14rem",
              }}
            >
              <PlusCircleOutlined style={{ color: "green" }} />
              Add Third Category
            </Button>
          </div>
        ) : (
          <div
            style={{
              marginLeft: "14rem",
              padding: "1rem",
              width: "100%",
            }}
          >
            <Form onFinish={onFinish2} ref={formRef2} form={form1}>
              <Row gutter={10} style={{ marginLeft: "0.5rem" }}>
                <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Third Category Name is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Third Category Name"
                      name="name"
                    />
                  </Form.Item>
                </Col>

                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <Form.Item>
                    <div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "1.8rem",
                              height: "1.8rem",
                              borderRadius: "50%",
                              backgroundColor: "#52c41a",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CheckOutlined
                              title="submit"
                              style={{
                                color: "#fff",
                                fontSize: "1.2rem",
                                fontWeight: "700",
                              }}
                            />
                          </div>
                        </div>
                      </Button>
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.7rem",
                          marginLeft: "0.9rem",
                        }}
                        title="delete"
                        twoToneColor="#eb2f96"
                        onClick={() => {
                          setTop(false);
                          // handleReset();
                        }}
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </Form>
    </>
  );
};

export default ThirdCategoryChild;
